import React, { Fragment, useState, useLayoutEffect, useContext } from "react";
import { AlignCenter } from "lucide-react";
import { Link } from "react-router-dom";
import { Image, UL } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
import TodoIcon from "./TodoIcon";
import BriefCase from "./BriefCase";
import BookmarkHeader from "./BookmarkHeader";
import styles from "./Leftbar.module.scss";

const Leftbar = () => {
  const { layoutURL, setToggleIcon, toggleSidebar, toggleIcon } =
    useContext(CustomizerContext);
  const windowSize = useWindowSize();

  function useWindowSize() {
    const [size, setSize] = useState({ width: 0, height: 0 });

    useLayoutEffect(() => {
      function updateSize() {
        // Sidebar aç/kapa kullanıcı kararıdır — resize/sayfa geçişinde
        // (scrollbar oynamasıyla tetiklenen resize dahil) compact'a ZORLAMA.
        // Eskiden `if (nextWidth > 1200) setToggleIcon(true)` her resize'da
        // menüyü kapatıyordu (kullanıcı feedback'i: sayfa geçişinde compact'a dönüyor).
        setSize({ width: window.innerWidth, height: window.innerHeight });
      }

      window.addEventListener("resize", updateSize);
      updateSize();

      return () => window.removeEventListener("resize", updateSize);
    }, []);

    return size;
  }

  // Sidebar toggle: tek source of truth = toggleIcon. Overlay React tarafında
  // toggleIcon'dan derive edilir; imperative DOM mutation YASAK (eski sürümde
  // querySelector + classList.toggle ile race condition yaratıyordu — React
  // re-render imperative class'ı siliyor → "sidebar açık ama overlay yok",
  // "kapatılamıyor" bug'ları).
  const responsive_openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  return (
    <Fragment>
      <div
        className={`header-logo-wrapper ${styles.colAuto}`}
        id="out_side_click"
      >
        <div className="logo-wrapper">
          <Link to="/">
            <Image
              attrImage={{
                className: "img-fluid for-light",
                src: `/logo-close.png`,
                alt: "",
              }}
            />
          </Link>
        </div>
        <div
          className={`toggle-sidebar ${styles.toggleSidebar} ${
            windowSize.width <= 1200 ? "" : styles.isHidden
          }`}
          onClick={responsive_openCloseSidebar}
        >
          <AlignCenter
            className="status_toggle middle sidebar-toggle"
            id="sidebar-toggle"
          />
        </div>
      </div>
      <div
        className={`nav-right pull-right right-header ${styles.smBlock} ${styles.colAuto}`}
      >
        <UL
          attrUL={{
            className: `simple-list nav-menus ${styles.navMenusUtil}`,
          }}
        >
          <TodoIcon />
          <BookmarkHeader />
          <BriefCase />
        </UL>
      </div>
    </Fragment>
  );
};

export default Leftbar;
